export function isChangeFullyApproved(change) {
  const approvals = change?.approvals ?? [];
  const firstApproved = approvals.some(
    (a) => a?.approverRole === '1st Approval' && a?.approvalStatus === 'APPROVED'
  );
  const secondApproved = approvals.some(
    (a) => a?.approverRole === '2nd Approval' && a?.approvalStatus === 'APPROVED'
  );
  return firstApproved && secondApproved;
}

export function isChangeLocked(change) {
  const status = String(change?.implementationStatus || '').toUpperCase();
  return status === 'COMPLETED' || isChangeFullyApproved(change);
}

export function implementationStatusAfterApprovals(approvals, currentStatus) {
  const list = approvals ?? [];
  const anyDeclined = list.some((a) => a?.approvalStatus === 'REJECTED');
  if (anyDeclined) return 'IN_PROGRESS';
  if (isChangeFullyApproved({ approvals: list })) return 'COMPLETED';
  const anyApproved = list.some((a) => a?.approvalStatus === 'APPROVED');
  if (anyApproved) return 'IN_PROGRESS';
  return currentStatus;
}
